// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { layoutStore } from '../../store/index.tsx';

export const useIsChromeless = createHook(layoutStore, {
	selector: (state) => state.isChromeless,
});
